"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultProps = require("./components/headers/header/defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _defaultProps3 = require("./components/headers/smartHeader/defaultProps");

var _defaultProps4 = _interopRequireDefault(_defaultProps3);

var _basicFormProps = require("./components/forms/basicForm/basicFormProps");

var _basicFormProps2 = _interopRequireDefault(_basicFormProps);

var _defaultProps5 = require("./components/banners/bannerWithCard/defaultProps");

var _defaultProps6 = _interopRequireDefault(_defaultProps5);

var _gridFormProps = require("./components/forms/gridForm/gridFormProps");

var _gridFormProps2 = _interopRequireDefault(_gridFormProps);

var _defaultProps7 = require("./components/footers/footer/defaultProps");

var _defaultProps8 = _interopRequireDefault(_defaultProps7);

var _defaultProps9 = require("./components/footers/fancyFooter/defaultProps");

var _defaultProps10 = _interopRequireDefault(_defaultProps9);

var _defaultProps11 = require("./components/mediaCards/informationCard/defaultProps");

var _defaultProps12 = _interopRequireDefault(_defaultProps11);

var _basicCardProps = require("./components/mediaCards/basicCard/basicCardProps");

var _basicCardProps2 = _interopRequireDefault(_basicCardProps);

var _portraitVideoProps = require("./components/mediaCards/portraitVideo/portraitVideoProps");

var _portraitVideoProps2 = _interopRequireDefault(_portraitVideoProps);

var _videoCardProps = require("./components/mediaCards/videoCard/videoCardProps");

var _videoCardProps2 = _interopRequireDefault(_videoCardProps);

var _basicBannerProps = require("./components/banners/basicBanner/basicBannerProps");

var _basicBannerProps2 = _interopRequireDefault(_basicBannerProps);

var _basicSliderProps = require("./components/sliders/basicSlider/basicSliderProps");

var _basicSliderProps2 = _interopRequireDefault(_basicSliderProps);

var _defaultProps13 = require("./components/productList/defaultProps");

var _defaultProps14 = _interopRequireDefault(_defaultProps13);

var _defaultProps15 = require("./layouts/threeEqualWidthColumn/defaultProps");

var _defaultProps16 = _interopRequireDefault(_defaultProps15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  basicBanner: _basicBannerProps2.default,
  bannerWithCard: _defaultProps6.default,
  basicCard: _basicCardProps2.default,
  basicForm: _basicFormProps2.default,
  basicSlider: _basicSliderProps2.default,
  footer: _defaultProps8.default,
  fancyFooter: _defaultProps10.default,
  gridForm: _gridFormProps2.default,
  header: _defaultProps2.default,
  threeEqualWidthColumn: _defaultProps16.default,
  portraitVideo: _portraitVideoProps2.default,
  informationCard: _defaultProps12.default,
  productList: _defaultProps14.default,
  smartHeader: _defaultProps4.default,
  videoCard: _videoCardProps2.default
};

// console.log("check props", defaultProps);
exports.default = defaultProps;